import React from 'react';
import ModalWrapper from '../../elements/ModalWrapper';
import FormFilter from './FormFilter';

export interface Data {
  startDate: string;
  endDate: string;
  categoryId: string;
}

interface ModalFilterProps {
  opened: boolean;
  data?: Data;
  onClose: () => void;
  onFilter: (data: any) => void;
  onReset?: () => void;
}

const ModalFilter: React.FC<ModalFilterProps> = ({
  opened,
  onClose,
  onFilter,
  onReset,
  data
}) => {
  return (
    <ModalWrapper isVisible={opened} onClose={onClose} title="Select Filter">
      <FormFilter onFilter={onFilter} data={data} onReset={onReset} />
    </ModalWrapper>
  );
};

export default ModalFilter;
